<template>
  <div id="app">
    <div v-if="$route.fullPath.toLocaleLowerCase().indexOf('daqi')<0 
            && $route.fullPath.toLocaleLowerCase().indexOf('nanzhuang') <0
            && $route.fullPath.toLocaleLowerCase().indexOf('getuseropenid') <0
            && $route.fullPath.toLocaleLowerCase().indexOf('download') <0
            && $route.fullPath.toLocaleLowerCase().indexOf('privacy-policy') <0
            && $route.fullPath.toLocaleLowerCase().indexOf('user-agreement') <0
            && $route.fullPath.toLocaleLowerCase().indexOf('needView') <0">
      <div class="topNavbox">
        <Header></Header>
      </div>
      <el-container>
        <el-header>
          <Banner></Banner>
        </el-header>
        <el-main>
          <router-view :key="$route.fullPath"></router-view>
        </el-main>
        <el-footer>
          <Footer></Footer>
        </el-footer>
      </el-container>
      <div class="fix">
        <el-backtop v-if="isMobile">
          <img :src="imgUrl.backtop" class="img-backtop" />
        </el-backtop>
        <fix-part v-else></fix-part>
      </div>
    </div>
    <div v-else>
      <router-view :key="$route.fullPath"></router-view>
    </div>

  </div>
</template>

<script>
import Header from './layout/Header.vue'
import Banner from './layout/Banner.vue'
import Footer from './layout/Footer.vue'
import FixPart from './components/FixPart.vue'
import imgUrl from './utils/imgUrl'

export default {
  name: 'App',
  data() {
    return {
      isMobile: window.innerWidth < 780,
      imgUrl
    }
  },
  components: {
    Header,
    Footer,
    Banner,
    "fix-part": FixPart
  },
  watch: {
    $route(to, from) {
      window.scrollTo(0, 0); // 滚动到顶部
    }
  },
  mounted() {
    window.addEventListener("resize", this.initFunc)
  },
  methods: {
    initFunc() {
      this.isMobile = window.innerWidth < 780
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.initFunc)
  },
}
</script>

<style scoped lang="less">
  * {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
  list-style: none;
  text-align: justify;
} 
.topNavbox{
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 1000;
  box-shadow: 10px 10px 20px #00000040;
}
/deep/ a {
  text-decoration: none;
  color: inherit;
}
a:hover { 
  text-decoration: none; 
  color: inherit;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.el-header{
  padding: 0 !important;
  height: unset !important;
}
.el-main{
  width: 100%;
  display: block;
  margin: 0 auto;
  padding: 0;
}
.el-footer{
  padding: 0;
}
.fix{
  position: fixed;
  right: 10px;
  bottom: 160px;
  z-index: 1000;
}
.img-backtop{
  padding: 0.4rem;
}

</style>
